import { Header } from '@yanolja-org/core-ui';
import { IcCartFillH18, IcCartH18 } from '@yanolja-org/nol-icons';

import type { HeaderCartActionProps, VisibleOn } from '@yanolja-org/core-ui';

/** preset 전용 — `'all'` 명시 시 양쪽 모두 노출. @see MyAction 의 PresetVisibleOn 주석 */
type PresetVisibleOn = VisibleOn | 'all';

export interface CartActionProps extends Omit<HeaderCartActionProps, 'icon' | 'activeIcon' | 'visibleOn'> {
  action?: string;
  /** 표시 디바이스. `'all'` = 양쪽 모두. @default 'desktop' */
  visibleOn?: PresetVisibleOn;
}

export function CartAction({
  action = 'cart',
  label = '장바구니',
  variant = 'label',
  visibleOn = 'desktop',
  href = '/cart',
  ...rest
}: CartActionProps) {
  return (
    <Header.CartAction
      {...rest}
      action={action}
      activeIcon={<IcCartFillH18 />}
      href={href}
      icon={<IcCartH18 />}
      label={label}
      variant={variant}
      visibleOn={visibleOn === 'all' ? undefined : visibleOn}
    />
  );
}
